import { render, staticRenderFns } from "./DashboardZonePresident.vue?vue&type=template&id=080c135c"
import script from "./DashboardZonePresident.vue?vue&type=script&lang=js"
export * from "./DashboardZonePresident.vue?vue&type=script&lang=js"
import style0 from "./DashboardZonePresident.vue?vue&type=style&index=0&id=080c135c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports